import { defineComponent as l, computed as n, createBlock as o, openBlock as d, unref as u, mergeProps as s, withCtx as b, renderSlot as c } from "vue";
import { RevButtonBase as f } from "@ds/components/ButtonBase";
import { tw as a } from "../../utils/tailwind.js";
const k = /* @__PURE__ */ l({
  name: "RevLink",
  inheritAttrs: !1,
  __name: "Link",
  props: {
    ariaDescribedby: { default: void 0 },
    ariaLabelledby: { default: void 0 },
    ariaLabel: { default: void 0 },
    to: { default: void 0 },
    underlined: { type: Boolean, default: !0 },
    tracking: { default: () => ({}) }
  },
  setup(e) {
    const i = e, r = n(() => [
      a`text-action-default-hi focus-visible-outline-default-hi rounded-sm font-weight-body-1-link cursor-pointer [text-align:inherit] hover:text-action-default-hi-hover`,
      i.underlined ? a`underline` : a`no-underline hover:underline`
    ]);
    return (t, m) => (d(), o(u(f), s({
      "aria-describedby": e.ariaDescribedby,
      "aria-label": e.ariaLabel,
      "aria-labelledby": e.ariaLabelledby
    }, t.$attrs, {
      class: r.value,
      to: e.to,
      tracking: e.tracking
    }), {
      default: b(() => [
        c(t.$slots, "default")
      ]),
      _: 3
    }, 16, ["aria-describedby", "aria-label", "aria-labelledby", "class", "to", "tracking"]));
  }
});
export {
  k as default
};
